import axios from "axios";

const dtAxiosObj = () => {
  let axiosConfig = {};

  axiosConfig.responseType = "json";
  axiosConfig.headers = {
    Pragma: "no-cache",
    "Content-Type": "application/json",
  };

  axiosConfig.baseURL = process.env.REACT_APP_DT_API_BASE_URL;

  if (process.env.REACT_APP_ENV == "DEV") {
    axiosConfig.auth = {
      username: "user",
      password: "3.comUXuat",
    };
  }

  axiosConfig.validateStatus = false;

  const axiosInstance = axios.create(axiosConfig);

  axiosInstance.interceptors.request.use(
    function(config) {
      return config;
    },
    function(error) {
      return Promise.reject(error);
    }
  );

  axiosInstance.interceptors.response.use(
    async (response) => {
      return response;
    },
    async (error) => {
      return Promise.reject(error);
    }
  );

  return axiosInstance;
};

export default class DtApiUtil {
  static getPlanOffers = async () => {
    let responseObj = dtAxiosObj().get("offer/getPlanOffers/");
    return responseObj;
  };

  static userLogin = async (id, pw) => {
    let responseObj = dtAxiosObj().post("user/login", {
      id: id,
      password: pw,
      showProf: true,
      rememberMe: false,
      existingCustDipping: true,
    });

    return responseObj;
  };

  static userGetProfile = async () => {
    let responseObj = dtAxiosObj().get("user/getProfile");
    return responseObj;
  };

  static userGetLoginStatus = async () => {
    let responseObj = dtAxiosObj().get("user/loginStatus");
    return responseObj;
  };

  static userGetProfilePic = async () => {
    let responseObj = dtAxiosObj().get(
      "user/getProfilePic?showCustProfilePic=true"
    );
    return responseObj;
  };

  static simGetProfilePic = async (subscriptionId) => {
    let responseObj = dtAxiosObj().get(
      "sim/" + subscriptionId + "/getProfilePic"
    );
    return responseObj;
  };

  /* Get Customer Level Pic */
  static getCustLevelProfilePic = async (userGetProfilePicResult) => {
    if (userGetProfilePicResult.status === 200) {
      return userGetProfilePicResult.data.profilePic !== undefined
        ? userGetProfilePicResult.data.profilePic
        : "";
    } else {
      return "";
    }
  };

  /* Get Sub Account Profile Pic */
  static getSubProfilePic = async (simGetProfilePicResult) => {
    if (simGetProfilePicResult.status === 200) {
      return simGetProfilePicResult.data.profilePic !== undefined
        ? simGetProfilePicResult.data.profilePic
        : "";
    } else {
      return "";
    }
  };

  /* Eats Axios Response of userGetLoginStatus */
  static getLoginStatusResult = async (loginStatusResponse) => {
    let returnObj = {
      isLogin: false,
      displayName: "",
      subscriptionId: "",
      serviceType:"",
    };

    console.log("DtApiUtil.getLoginStatusResult()");

    if (loginStatusResponse.status === 200) {
      console.log(
        "DtApiUtil.getLoginStatusResult() => Has previous login result"
      );
      returnObj.isLogin = true;

      if (loginStatusResponse.data.msisdn !== undefined) {
        returnObj.displayName = loginStatusResponse.data.msisdn;
      }

      if (returnObj.displayName === "") {
        if (loginStatusResponse.data.email !== undefined) {
          returnObj.displayName = loginStatusResponse.data.email;
        }
      }

      if (loginStatusResponse.data.custId !== "") {
        returnObj.subscriptionId = "";
      }

      if (returnObj.subscriptionId === "") {
        if (loginStatusResponse.data.subscriptionId !== undefined) {
          returnObj.subscriptionId = loginStatusResponse.data.subscriptionId;
        }
      }

      if (returnObj.serviceType === "") {
        if (loginStatusResponse.data.serviceType !== undefined) {
          returnObj.serviceType = loginStatusResponse.data.serviceType;
        }
      }

    }

    return returnObj;
  };

  /* Eats Axios Response of userLogin */
  static getLoginResult = async (loginResponse) => {
    let returnObj = {
      isDtValidLogin: false,
      tryThreeCare: false,
      dtProfile: null,
    };

    console.log("DtApiUtil.getLoginResult()");

    if (loginResponse.status === 200 || loginResponse.status === 202) {
      console.log("DtApiUtil.getLoginResult() => DT Customer successful login");
      returnObj.isDtValidLogin = true;
      returnObj.dtProfile = loginResponse.data;
    } else if (loginResponse.status === 400) {
      if (loginResponse.data !== undefined && loginResponse.data !== null) {
        let existingCust = loginResponse.data.existingCust;

        if (
          existingCust !== undefined &&
          existingCust !== null &&
          existingCust === true
        ) {
          returnObj.isDtValidLogin = false;
        } else {
          returnObj.tryThreeCare = true;
        }
      } else {
        console.log(
          "DtApiUtil.getLoginResult() => DT Login API pure 400, fall back to BAU"
        );
        returnObj.tryThreeCare = true;
      }
    } else if (loginResponse.status === 406) {
      /* 406: Already Login */
      returnObj.isDtValidLogin = true;
    } else {
      /* Other Error */
      console.log(
        "DtApiUtil.getLoginResult() => DT Login API other unsupported code, fall back to BAU"
      );
      returnObj.tryThreeCare = true;
    }

    return returnObj;
  };

  static handleProfile = async (profile) => {
    let returnObj = {
      displayName: "",
      isPrimaryAccount: false,
      subscriptionId: "",
    };

    console.log("DtApiUtil.handleProfile()");
    console.log(profile);

    console.log(
      "DtApiUtil.handleProfile() => isPrimaryUser=" + profile.isPrimaryUser
    );

    /* Is primary user */
    if (profile.isPrimaryUser == true) {
      returnObj.isPrimaryAccount = true;
      if (
        profile.subscriptions !== undefined &&
        profile.subscriptions !== null
      ) {
        let subscriptionArray = profile.subscriptions;
        let subscriptionSize = subscriptionArray.length;

        console.log(
          "DtApiUtil.handleProfile() => subscriptionSize=" + subscriptionSize
        );

        if (subscriptionSize > 0) {
          let filteredsubScriptions = subscriptionArray.filter(
            (s) => s.primarySubsInd === true
          );
          returnObj.displayName = filteredsubScriptions[0].primaryMsisdn;
        } else {
          returnObj.displayName = profile.email;
        }
      } else {
        returnObj.displayName = profile.email;
      }
    } else {
      /* Otherwise */
      if (
        profile.subscriptions !== undefined &&
        profile.subscriptions !== null
      ) {
        let subscriptionArray = profile.subscriptions;
        let subscriptionSize = subscriptionArray.length;

        console.log(
          "DtApiUtil.handleProfile() => subscriptionSize=" + subscriptionSize
        );

        if (subscriptionSize > 0) {
          returnObj.subscriptionId = subscriptionArray[0].subscriptionId;
          returnObj.displayName = subscriptionArray[0].primaryMsisdn;
        }
      } else {
      }
    }

    return returnObj;
  };

  static checkLoginId = async (id,lang) => {
    let apiResponse;

    const url = process.env.REACT_APP_CHECK_LOGIN_ID_API;

    await axios
      .post(url, {
        id,
        lang,
      })
      .then((response) => {
        console.log(response);
        apiResponse = response.data;
      })
      .catch((error) => {
        console.log(error);
      });

    return apiResponse;
  };
}
